<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        v-on="on"
        v-bind="attrs"
        color="error"        
        x-small                
        > <v-icon size="12">mdi-close</v-icon> Cancelar</v-btn
      >
    </template>
    <v-card>
      <v-card-title>Cancelar indicação</v-card-title>
      <v-card-text class="subtitle-1">

        Confirma o cancelamento da indicação do PCD <b>{{ indicacao.nome }}</b> ??

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelarIndicacao()" color="error" rounded
          >Sim, cancelar</v-btn
        >
        <v-btn text @click="dialog = false" rounded>Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions } from 'vuex';
export default {
  props: {
    indicacao: Object
  },  
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapActions("pcd",["getMinhasIndicacoes"]),
    async cancelarIndicacao() {
      await axios
        .post("/colaborador/indicacao-pcd/alterar-status-solicitacao", JSON.stringify({
          id: this.indicacao.id,
          status: 9,
          tiposistema: "WEB",
          observacao: "Cancelado pelo usuário"
        }))
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            await this.getMinhasIndicacoes()
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
    },
  },
};
</script>

<style>
</style>